import { ContentAudience } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import constants from '../../common/constants';
import { ContentAudienceOptions } from '../utils/SelectableOptions';
import MetadataTileInput from '../workflow-viewer/content/MetadataTileInput';

interface Props {
  formId: string;
  contentId: string;
  contentAudience?: ContentAudience;
  onAudienceUpdate?: (contentAudience: ContentAudience) => void;
}

interface State {
  updatedContentAudience: ContentAudience;
}

class ContentAudienceForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      // @ts-expect-error TS2322 - strict migration
      updatedContentAudience: this.props.contentAudience,
    };
  }

  public render() {
    const { updatedContentAudience } = this.state;
    return (
      <div className="awsui">
        <MetadataTileInput
          sectionId="contentAudience"
          selectedTile={updatedContentAudience}
          tileOptions={ContentAudienceOptions}
          label={constants.CONTENT_AUDIENCE_LABEL}
          placeholder={constants.CONTENT_AUDIENCE_PLACEHOLDER}
          onInputUpdated={this.handleContentAudienceChanged}
          stretch
          visible
        />
      </div>
    );
  }

  private handleContentAudienceChanged = (
    sectionId: string,
    selectedId: string,
    validationError?: string,
  ) => {
    // @ts-expect-error TS7053 - strict migration
    const updatedContentAudience = ContentAudience[selectedId];
    this.setState({ updatedContentAudience });
    // @ts-expect-error TS2722 - strict migration
    this.props.onAudienceUpdate(updatedContentAudience);
  };
}

export default ContentAudienceForm;
